import { cacheJSONtime } from '../config/cache.config';

/**
 * Try to get data from session storage if the file name is on it
 * @param fileName File name to check if is cached on session storage
 * @returns null / JSON object depending if file name is finded on session storage
 */
export const getDataFromCache = (fileName) => JSON.parse(sessionStorage.getItem(`DKT-cache-${fileName}`));

/**
 * Add a session storage item with the file name as key's part
 * @param fileName File name to create key in session storage
 * @param value JSON object to save as value on session storage
 */
export const addFileToCache = (fileName, value) => sessionStorage.setItem(`DKT-cache-${fileName}`, JSON.stringify(value));

/**
 * Remove session storage item which file name match with existing key
 * @param fileName File name to delete session storage item
 */
export const deleteFileFromCache = (fileName) => sessionStorage.removeItem(`DKT-cache-${fileName}`);

/**
 * Checks if file name session storage key exist and if its timestamp has timed out.
 * On that case, remove from session storage
 * @param fileName File name to search on session storage key
 */
export const manageCacheTime = (fileName) => {
  let empty = false;
  const cacheData = getDataFromCache(fileName);
  const cacheMaxTime = cacheData ? cacheData.timestamp + cacheJSONtime * 60 * 1000 : null;
  if(cacheData && cacheMaxTime && cacheMaxTime <= new Date().getTime()){
    deleteFileFromCache('active-functionalities');
    empty = true;
  }
  return empty;
};



// WEBPACK FOOTER //
// ./src/_override/common/cache.js